import { render, staticRenderFns } from "./ListEdit.vue?vue&type=template&id=1952d77a&"
import script from "./ListEdit.vue?vue&type=script&lang=js&"
export * from "./ListEdit.vue?vue&type=script&lang=js&"
import style0 from "./ListEdit.vue?vue&type=style&index=0&id=1952d77a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports